import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { tokens, Button, Text } from '@hotjar/hotsauce';
import personReading from '@hotjar/shared-assets/images/person-reading-GA-book.png';

const Container = styled.div`
  padding: 0 ${tokens.spacer.x4};
  width: 100%;
  margin: 0 auto;
  max-width: 650px;
`;

const ContentContainer = styled.div`
  dislay: flex;
  align-items: center;
  justify-content: center;

  max-width: 400px;
`;

const ImageContainer = styled.div`
  width: 100%;
  margin-bottom: ${tokens.spacer.x2};
`;

const StyledImage = styled.img`
  width: 100%;
`;
const StyledText = styled(Text)`
  text-align: left;
  margin-bottom: ${tokens.spacer.x2};
`;

const Title = styled.h3`
  ${tokens.text('header5')};
  color: ${tokens.color.text_default};
  margin-bottom: ${tokens.spacer.x2};
`;

const SubTitle = styled.h4`
  ${tokens.text('body1')};
  color: ${tokens.color.text_light};
  margin-bottom: ${tokens.spacer.x2};
`;

export const SideContent = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Container>
      <div>
        <ImageContainer>
          <StyledText as="p" textColor="text_light">
            {t('common:login.side-image-rebranded.section-title')}
          </StyledText>
          <StyledImage src={personReading} />
        </ImageContainer>
        <ContentContainer>
          <Title>{t('common:login.side-image-rebranded.title')}</Title>
          <SubTitle>{t('common:login.side-image-rebranded.subtitle')}</SubTitle>
          <Button kind="secondary" as="a" isExternal href="https://www.hotjar.com/guides/">
            {t('common:login.side-image-rebranded.action')}
          </Button>
        </ContentContainer>
      </div>
    </Container>
  );
};
